import { Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-work-exp",
  templateUrl: "./work-exp.component.html",
  styleUrls: ["./work-exp.component.css"]
})
export class WorkExpComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  showContract = false;
  // uni&spec
  allEmployee:any=[];
  allCompany:any=[];
  allJob:any=[];
  // datepicker
  minDate = new Date();
	maxDate = new Date();
	today: Date | undefined;
  
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.form = this.formBuilder.group({
      employementTypeId: [""],
      jobTitle: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      companyName: ["", Validators.compose([Validators.required,Validators.maxLength(50)])],
      underContractOf: [""],
      fromDate: ["",Validators.compose([Validators.required])],
      toDate: ["",Validators.compose([Validators.required])],
      description: ["", Validators.compose([ Validators.minLength(3),Validators.maxLength(250)])],
      location: [""],
      isCurrentlyRole: [""],
      // zipCode: [""],
      // latitude: [""],
      // longitude: [""],
    });
   }

  ngOnInit(): void {
    this.getEmpType();
    this.getExpDetail();
  }
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
 // getUniSpec
 getExpDetail(){
  this.api.showLoader=false;
  this.api.loader(false)
  this.api.getDatas(apiUrl._getWorkExp)
  .subscribe(async (res) => {
    if(res.data != ""){
      this.router.navigate(["/experience/add"]);
    } else{
      this.router.navigate(["/experience"]);
    }
  })
} 
  // getUniSpec
  getEmpType(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._allEmpType)
    .subscribe(async (res) => {
      this.allEmployee = res.data.listing;
     })
  } 
  // selected employee
  selectedEmployment(i,event){ 
    this.allEmployee.map((emp)=>{
      emp["selected"] = false
      event.srcElement.classList.remove("selected")
      if(event.target.innerHTML){this.showContract=false;}
    })
    this.allEmployee[i]["selected"] = true
    event.srcElement.classList.add("selected") 
    if(event.target.innerHTML == "Contractual"){this.showContract=true;} 
  }
  // on submit
  onSubmit(){
    let employeeType = ""
    this.allEmployee.map((employee) => {
      if(employee["selected"] == true) {
        if (employeeType == "") {
          employeeType = employee.id
        } else {
          employeeType = employeeType + "," + employee.id
        }
      }
    })
    this.form.value.employementTypeId =employeeType;
    this.form.patchValue({
      employementTypeId:employeeType
    }) 
    if(this.form.value.isCurrentlyRole == 1 || this.form.value.isCurrentlyRole == true){
      this.form.patchValue({
        isCurrentlyRole : 1
      })
    }
    if(this.form.value.underContractOf == ""){
      delete this.form.value.underContractOf;
    }
    if(this.form.valid){ 
      this.api.postData(apiUrl._addWorkExp, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.toastrService.success("", "Work Experience Added Successfully!");
        this.modalRef?.hide();
        this.router.navigate(["/experience/add"]);
      })
    } else{
      this.showError= true;
      setTimeout(() => {
        this.showError= false;
      }, 3000);
    }
    
  }

  isDisabled(event:any){
    if(event.target.checked) {
      this.form.controls['toDate'].disable();
    } else {
      this.form.controls['toDate'].enable();
    }
  }
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
}
